export const DOCUMENT_REQUEST_STATUS_LABELS = {
    pending: 'در انتظار آپلود', submitted: 'در انتظار بررسی مدیر', completed: 'تکمیل‌شده', cancelled: 'لغوشده',
};
//# sourceMappingURL=document-recovery.js.map